import _taggedTemplateLiteral from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: flex;\n        align-items: center;\n      }\n\n      :host([hidden]) {\n        display: none !important;\n      }\n\n      :host([orientation=\"vertical\"]) {\n        display: block;\n      }\n\n      :host([orientation=\"horizontal\"]) [part=\"tabs\"] {\n        flex-grow: 1;\n        display: flex;\n        align-self: stretch;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        -ms-overflow-style: none;\n      }\n\n      /* This seems more future-proof than `overflow: -moz-scrollbars-none` which is marked obsolete\n         and is no longer guaranteed to work:\n         https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#Mozilla_Extensions */\n      @-moz-document url-prefix() {\n        :host([orientation=\"horizontal\"]) [part=\"tabs\"] {\n          overflow: hidden;\n        }\n      }\n\n      :host([orientation=\"horizontal\"]) [part=\"tabs\"]::-webkit-scrollbar {\n        display: none;\n      }\n\n      :host([orientation=\"vertical\"]) [part=\"tabs\"] {\n        height: 100%;\n        overflow-y: auto;\n        -webkit-overflow-scrolling: touch;\n      }\n\n      [part=\"back-button\"],\n      [part=\"forward-button\"] {\n        pointer-events: none;\n        opacity: 0;\n        cursor: default;\n      }\n\n      :host([overflow~=\"start\"]) [part=\"back-button\"],\n      :host([overflow~=\"end\"]) [part=\"forward-button\"] {\n        pointer-events: auto;\n        opacity: 1;\n      }\n\n      [part=\"back-button\"]::after {\n        content: '\u25C0';\n      }\n\n      [part=\"forward-button\"]::after {\n        content: '\u25B6';\n      }\n\n      :host([orientation=\"vertical\"]) [part=\"back-button\"],\n      :host([orientation=\"vertical\"]) [part=\"forward-button\"] {\n        display: none;\n      }\n    </style>\n    <div on-click=\"_scrollBack\" part=\"back-button\"></div>\n\n    <div id=\"scroll\" part=\"tabs\">\n      <slot></slot>\n    </div>\n\n    <div on-click=\"_scrollForward\" part=\"forward-button\"></div>\n"], ["\n    <style>\n      :host {\n        display: flex;\n        align-items: center;\n      }\n\n      :host([hidden]) {\n        display: none !important;\n      }\n\n      :host([orientation=\"vertical\"]) {\n        display: block;\n      }\n\n      :host([orientation=\"horizontal\"]) [part=\"tabs\"] {\n        flex-grow: 1;\n        display: flex;\n        align-self: stretch;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        -ms-overflow-style: none;\n      }\n\n      /* This seems more future-proof than \\`overflow: -moz-scrollbars-none\\` which is marked obsolete\n         and is no longer guaranteed to work:\n         https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#Mozilla_Extensions */\n      @-moz-document url-prefix() {\n        :host([orientation=\"horizontal\"]) [part=\"tabs\"] {\n          overflow: hidden;\n        }\n      }\n\n      :host([orientation=\"horizontal\"]) [part=\"tabs\"]::-webkit-scrollbar {\n        display: none;\n      }\n\n      :host([orientation=\"vertical\"]) [part=\"tabs\"] {\n        height: 100%;\n        overflow-y: auto;\n        -webkit-overflow-scrolling: touch;\n      }\n\n      [part=\"back-button\"],\n      [part=\"forward-button\"] {\n        pointer-events: none;\n        opacity: 0;\n        cursor: default;\n      }\n\n      :host([overflow~=\"start\"]) [part=\"back-button\"],\n      :host([overflow~=\"end\"]) [part=\"forward-button\"] {\n        pointer-events: auto;\n        opacity: 1;\n      }\n\n      [part=\"back-button\"]::after {\n        content: '\u25C0';\n      }\n\n      [part=\"forward-button\"]::after {\n        content: '\u25B6';\n      }\n\n      :host([orientation=\"vertical\"]) [part=\"back-button\"],\n      :host([orientation=\"vertical\"]) [part=\"forward-button\"] {\n        display: none;\n      }\n    </style>\n    <div on-click=\"_scrollBack\" part=\"back-button\"></div>\n\n    <div id=\"scroll\" part=\"tabs\">\n      <slot></slot>\n    </div>\n\n    <div on-click=\"_scrollForward\" part=\"forward-button\"></div>\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { ThemableMixin } from '@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js';
import { ListMixin } from '@vaadin/vaadin-list-mixin/vaadin-list-mixin.js';
import { IronResizableBehavior } from '@polymer/iron-resizable-behavior/iron-resizable-behavior.js';
import { ElementMixin } from '@vaadin/vaadin-element-mixin/vaadin-element-mixin.js';
import './vaadin-tab.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { afterNextRender } from '@polymer/polymer/lib/utils/render-status.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
var safari10 = /Apple.* Version\/(9|10)/.test(navigator.userAgent);
/**
 * `<vaadin-tabs>` is a Web Component for easy switching between different views.
 *
 * ```
 *   <vaadin-tabs selected="4">
 *     <vaadin-tab>Page 1</vaadin-tab>
 *     <vaadin-tab>Page 2</vaadin-tab>
 *     <vaadin-tab>Page 3</vaadin-tab>
 *     <vaadin-tab>Page 4</vaadin-tab>
 *   </vaadin-tabs>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name         | Description
 * ------------------|--------------------------------------
 * `back-button`     | Button for moving the scroll back
 * `tabs`            | The tabs container
 * `forward-button`  | Button for moving the scroll forward
 *
 * The following state attributes are available for styling:
 *
 * Attribute  | Description | Part name
 * -----------|-------------|------------
 * `orientation` | Tabs disposition, valid values are `horizontal` and `vertical`. | :host
 * `overflow` | It's set to `start`, `end`, none or both. | :host
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @memberof Vaadin
 * @mixes Vaadin.ElementMixin
 * @mixes Vaadin.ListMixin
 * @mixes Vaadin.ThemableMixin
 * @demo demo/index.html
 */

var TabsElement =
/*#__PURE__*/
function (_ElementMixin) {
  _inherits(TabsElement, _ElementMixin);

  function TabsElement() {
    _classCallCheck(this, TabsElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(TabsElement).apply(this, arguments));
  }

  _createClass(TabsElement, [{
    key: "ready",
    value: function ready() {
      var _this = this;

      _get(_getPrototypeOf(TabsElement.prototype), "ready", this).call(this);

      this.addEventListener('iron-resize', function () {
        return _this._updateOverflow();
      });

      this._scrollerElement.addEventListener('scroll', function () {
        return _this._updateOverflow();
      });

      this.setAttribute('role', 'tablist'); // Wait for the vaadin-tab elements to upgrade and get styled

      afterNextRender(this, function () {
        _this._updateOverflow();
      });
    }
  }, {
    key: "_scrollForward",
    value: function _scrollForward() {
      this._scroll(this._scrollOffset);
    }
  }, {
    key: "_scrollBack",
    value: function _scrollBack() {
      this._scroll(-1 * this._scrollOffset);
    }
  }, {
    key: "_updateOverflow",
    value: function _updateOverflow() {
      var scrollPosition = this._vertical ? this._scrollerElement.scrollTop : this._scrollerElement.scrollLeft;
      var scrollSize = this._vertical ? this._scrollerElement.scrollHeight : this._scrollerElement.scrollWidth; // In Edge we need to adjust the size in 1 pixel

      scrollSize -= 1;
      var overflow = scrollPosition > 0 ? 'start' : '';
      overflow += scrollPosition + this._scrollOffset < scrollSize ? ' end' : '';
      overflow ? this.setAttribute('overflow', overflow.trim()) : this.removeAttribute('overflow');

      this._repaintShadowNodesHack();
    }
  }, {
    key: "_repaintShadowNodesHack",
    value: function _repaintShadowNodesHack() {
      // Safari 10 has an issue with repainting shadow root element styles when a host attribute changes.
      // Need this workaround (toggle any inline css property on and off) until the issue gets fixed.

      /* istanbul ignore if */
      if (safari10 && this.root) {
        var WEBKIT_PROPERTY = '-webkit-backface-visibility';
        this.root.querySelectorAll('*').forEach(function (el) {
          el.style[WEBKIT_PROPERTY] = 'visible';
          el.style[WEBKIT_PROPERTY] = '';
        });
      }
    }
  }, {
    key: "_scrollOffset",
    get: function get() {
      return this._vertical ? this._scrollerElement.offsetHeight : this._scrollerElement.offsetWidth;
    }
  }, {
    key: "_scrollerElement",
    get: function get() {
      return this.$.scroll;
    }
  }], [{
    key: "template",
    get: function get() {
      return html(_templateObject());
    }
  }, {
    key: "is",
    get: function get() {
      return 'vaadin-tabs';
    }
  }, {
    key: "version",
    get: function get() {
      return '3.0.5';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        /**
         * Set tabs disposition. Possible values are `horizontal|vertical`
         */
        orientation: {
          value: 'horizontal',
          type: String
        },

        /**
         * The index of the selected tab.
         */
        selected: {
          value: 0,
          type: Number
        }
      };
    }
  }, {
    key: "observers",
    get: function get() {
      return ['_updateOverflow(items.*, vertical)'];
    }
  }]);

  return TabsElement;
}(ElementMixin(ListMixin(ThemableMixin(mixinBehaviors([IronResizableBehavior], PolymerElement)))));

customElements.define(TabsElement.is, TabsElement);
export { TabsElement };